import { observer } from 'mobx-react-lite'
import { Button, FullPageWrapper, IconButton, Typography } from 'shared/ui'
import { ProgressSteps } from 'shared/ui/ProgressSteps'
import { useRcsWizardContext } from 'pages/settings/pages/rcsV2/context/rcsWizardContext'
import { RcsWizardSteps } from 'pages/settings/pages/rcsV2/route/type'
import { SenderProfileForm } from './SenderProfileForm/SenderProfileForm'
import { SenderPreview } from './SenderPreview/SenderPreview'

import styles from './styles.module.scss'

export const SenderDetails = observer(() => {
  const { navigationStore, closeWizard, senderStore } = useRcsWizardContext()

  const onNext = () => {
    if (senderStore.validate()) return

    navigationStore.goToNextStep(RcsWizardSteps.senderDetails)
  }

  return (
    <FullPageWrapper className={styles.page}>
      <div className={styles.wrap}>
        <div className={styles.main}>
          <div className={styles.header}>
            <Typography variant='body-xs-regular' className={styles.badge} ariaLabel='RCS'>
              RCS
            </Typography>
            <ProgressSteps
              title='Sender details'
              step={navigationStore.getStepNumber(RcsWizardSteps.senderDetails)}
              total={navigationStore.allStepsLength}
            />
          </div>
          <div className={styles.formArea}>
            <SenderProfileForm />
          </div>
          <div className={styles.actions}>
            <Button text='Next' size='large' onClick={onNext} className={styles.nextButton} />
          </div>
        </div>
        <div className={styles.preview}>
          <SenderPreview />
        </div>
        <IconButton
          className={styles.close}
          ariaLabel='close_setting'
          icon='close'
          variant='icon'
          color='tertiary'
          size='medium'
          onClick={closeWizard}
        />
      </div>
    </FullPageWrapper>
  )
})
